// extracted by mini-css-extract-plugin
export default {"container":"quote-table-header_container__cgz7N"};